// 15 seconds
export const M_SECONDS_POOLING_INTERVAL_DATA_TECH = 15 * 1000;
// 15 seconds
export const M_SECONDS_POOLING_OPERATOR_INTERVAL_DATA = 15 * 1000;
// 1 min
export const M_SECONDS_POOLING_INTERVAL_DATA = 60 * 1000;
// 1 day
export const M_SECONDS_KEEP_UNUSED_DATA_FOR_MAX_CACHE = 1 * 24 * 60 * 60 * 1000;
